<template>
  <div class="placeholder-page">
    <el-empty description="APP端技能库正在建设中">
      <el-button type="primary" @click="goBack">返回首页</el-button>
    </el-empty>
  </div>
</template>

<script>
export default {
  name: 'AppIndex',
  methods: {
    goBack() {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>
.placeholder-page {
  /* 撑满内容区，内容垂直水平居中 */
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
